import { render, staticRenderFns } from "./ProjectWindowView.vue?vue&type=template&id=246dda1e&scoped=true&"
import script from "./ProjectWindowView.vue?vue&type=script&lang=js&"
export * from "./ProjectWindowView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246dda1e",
  null
  
)

export default component.exports